import "./style.scss";

export default function ButtonSecondary({ btnContent, onClick, disabled }) {
  return (
    <button className="button-secondary" onClick={onClick} disabled={disabled}>
      {btnContent}
    </button>
  );
}
